import { Button, Divider } from "@mui/material";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useKothar from "context/useKothar";
import { clearSession, getStoredMemberships, ORG_DELETED_MESSAGE } from "utils/organizationAccess";
import OrganizationSwitcher from "views/admin/Preferences/OrganizationSwitcher";

export default function OrganizationDeleted() {
  const navigate = useNavigate();
  const [, { setToken }] = useKothar();

  const handleSignOut = () => {
    clearSession();
    setToken("");
    navigate("/login");
  };

  let orgName = "";
  try {
    const user = JSON.parse(localStorage.getItem("userDetail") || "{}");
    orgName = user?.organization || "";
  } catch {
    orgName = "";
  }

  const hasOtherOrganizations = useMemo(() => getStoredMemberships().length > 1, []);

  return (
    <div className="container mx-auto px-4 h-full">
      <div className="flex content-center items-center justify-center h-full min-h-screen">
        <div className="w-full lg:w-5/12 px-4">
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-app-surface border border-app-border">
            <div className="rounded-t mb-0 px-6 py-8 text-center">
              <h3 className="text-app-text text-xl font-bold">Organization unavailable</h3>
              {orgName ? <p className="text-app-text-muted text-sm mt-2">{orgName}</p> : null}
            </div>

            <div className="flex-auto px-6 lg:px-10 pb-10 pt-0 text-center space-y-4">
              <p className="text-app-text-muted text-sm leading-relaxed">{ORG_DELETED_MESSAGE}</p>
              <p className="text-app-text-muted text-xs">
                You can sign in, but your data cannot be viewed or changed until your organization
                is restored by an administrator.
              </p>

              {hasOtherOrganizations && (
                <>
                  <Divider />
                  <p className="text-app-text-muted text-xs">
                    You belong to other organizations. Switch to one of them to keep working.
                  </p>
                  <div className="text-left">
                    <OrganizationSwitcher />
                  </div>
                </>
              )}

              <Button variant="contained" fullWidth onClick={handleSignOut}>
                Sign out
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
